import React from 'react';

import {formatDate} from 'utils/datetime';
import ButtonDropdown from 'components/ButtonDropdown';
import Money from 'components/Money';

import gocardlessIcon from './assets/co-cardless-logo.svg';

import './styles.css';

const PaymentInfo = ({
  gocardlessPayment,
  cancelGocardlessPayment,
  retryGocardlessPayment
}) => (
  <div className="PaymentInfo">
    <div className="baseInfo">
      <div className="gocardlessInfo">
        <img src={gocardlessIcon} alt="Gocardless Icon" />
        <div className="launch">
          <p className="dateCreated">
            Created {formatDate(gocardlessPayment.createdAt)}
          </p>
        </div>
      </div>
      <div className="amount">
        <p className="header">Amount</p>
        <p className="value">
          <Money amount={gocardlessPayment.amount} />
        </p>
      </div>
    </div>
    <div className="options">
      <ButtonDropdown title="GC Payment Options">
        <ButtonDropdown.Option
          disabled={!gocardlessPayment.isCancelPossible}
          onClick={cancelGocardlessPayment}>
          Cancel
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          disabled={!gocardlessPayment.isRetryPossible}
          onClick={retryGocardlessPayment}>
          Retry
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  </div>
);

export default PaymentInfo;
